<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :form-fields="{model: []}"
                      :url="url"
                      :permission="{}"
                      :searchs="searchs"
                      :operate="[]"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "RechargeRebate",
        components: {CommonTable},
        data() {
            return {
                searchs:[{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                },{
                    name: 'rechargePhone',
                    placeholder: '充值用户',
                    type: 'input'
                },{
                    name: 'phone',
                    placeholder: '返利用户',
                    type: 'input'
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                url: {
                    get: '/rechargeRebate/listByCondition',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'rechargePhone',
                    label: '充值用户',
                    show: true,
                    width: '',
                }, {
                    field: 'money',
                    label: '充值金额(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'ratio',
                    label: '返佣比例',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    width: '',
                }, {
                    field: 'phone',
                    label: '返利用户',
                    show: true,
                    width: '',
                }, {
                    field: 'earnings',
                    label: '返利(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'createTime',
                    label: '返利时间',
                    show: true,
                    width: '',
                }],
            }
        }
    }
</script>

<style scoped>

</style>
